/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import { ProjectToolTipFragmentDoc } from "../hex/ProjectTooltip.generated";
import {
  StatusFragmentDoc,
  CategoryFragmentDoc,
} from "../app/ProjectLabels.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type MentionUserInfoQueryVariables = Types.Exact<{
  userId: Types.Scalars["UserId"]["input"];
}>;

export type MentionUserInfoQuery = {
  readonly __typename: "Query";
  readonly userById: {
    readonly __typename: "User";
    readonly id: c.UserId;
    readonly name: string | null;
    readonly email: string;
    readonly imageUrl: string | null;
  };
};

export type MentionGroupInfoQueryVariables = Types.Exact<{
  groupId: Types.Scalars["GroupId"]["input"];
}>;

export type MentionGroupInfoQuery = {
  readonly __typename: "Query";
  readonly groupById: {
    readonly __typename: "Group";
    readonly id: c.GroupId;
    readonly name: string;
  };
};

export type MentionHexInfoQueryVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
}>;

export type MentionHexInfoQuery = {
  readonly __typename: "Query";
  readonly hexById: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly hexType: Types.HexType;
    readonly currentDraft: {
      readonly __typename: "HexVersion";
      readonly id: c.HexVersionId;
      readonly title: string;
      readonly description: string | null;
    };
    readonly lastPublishedVersion: {
      readonly __typename: "HexVersion";
      readonly id: c.HexVersionId;
    } | null;
  };
};

export type MentionTableSummaryByIdQueryVariables = Types.Exact<{
  dataSourceTableId: Types.Scalars["DataSourceTableId"]["input"];
}>;

export type MentionTableSummaryByIdQuery = {
  readonly __typename: "Query";
  readonly dataSourceTableById: {
    readonly __typename: "DataSourceTable";
    readonly id: c.DataSourceTableId;
    readonly name: string;
    readonly dbtDescription: string | null;
    readonly comment: string | null;
    readonly pinned: boolean;
    readonly dataSourceSchema: {
      readonly __typename: "DataSourceSchema";
      readonly id: c.DataSourceSchemaId;
      readonly name: string;
      readonly metadata: {
        readonly __typename: "DataSourceSchemaMetadata";
        readonly id: c.DataSourceSchemaMetadataId;
        readonly status: {
          readonly __typename: "Status";
          readonly id: c.StatusId;
          readonly name: string;
          readonly color: Types.HexColor;
          readonly description: string | null;
          readonly inLibrary: boolean;
          readonly endorsed: boolean;
          readonly icon: Types.IconType | null;
        } | null;
      } | null;
      readonly dataSourceDatabase: {
        readonly __typename: "DataSourceDatabase";
        readonly id: c.DataSourceDatabaseId;
        readonly name: string | null;
        readonly dataConnectionId: c.DataConnectionId;
        readonly metadata: {
          readonly __typename: "DataSourceDatabaseMetadata";
          readonly id: c.DataSourceDatabaseMetadataId;
          readonly status: {
            readonly __typename: "Status";
            readonly id: c.StatusId;
            readonly name: string;
            readonly color: Types.HexColor;
            readonly description: string | null;
            readonly inLibrary: boolean;
            readonly endorsed: boolean;
            readonly icon: Types.IconType | null;
          } | null;
        } | null;
      };
    };
    readonly metadata: {
      readonly __typename: "DataSourceTableMetadata";
      readonly id: c.DataSourceTableMetadataId;
      readonly magicDescription: string | null;
      readonly status: {
        readonly __typename: "Status";
        readonly id: c.StatusId;
        readonly name: string;
        readonly color: Types.HexColor;
        readonly description: string | null;
        readonly inLibrary: boolean;
        readonly endorsed: boolean;
        readonly icon: Types.IconType | null;
      } | null;
    } | null;
  };
};

export const MentionUserInfoDocument = /*#__PURE__*/ gql`
  query MentionUserInfo($userId: UserId!) {
    userById(userId: $userId) {
      id
      name
      email
      imageUrl
    }
  }
`;

/**
 * __useMentionUserInfoQuery__
 *
 * To run a query within a React component, call `useMentionUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useMentionUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMentionUserInfoQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useMentionUserInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    MentionUserInfoQuery,
    MentionUserInfoQueryVariables
  > &
    (
      | { variables: MentionUserInfoQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MentionUserInfoQuery, MentionUserInfoQueryVariables>(
    MentionUserInfoDocument,
    options,
  );
}
export function useMentionUserInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MentionUserInfoQuery,
    MentionUserInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MentionUserInfoQuery,
    MentionUserInfoQueryVariables
  >(MentionUserInfoDocument, options);
}
export function useMentionUserInfoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MentionUserInfoQuery,
    MentionUserInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MentionUserInfoQuery,
    MentionUserInfoQueryVariables
  >(MentionUserInfoDocument, options);
}
export type MentionUserInfoQueryHookResult = ReturnType<
  typeof useMentionUserInfoQuery
>;
export type MentionUserInfoLazyQueryHookResult = ReturnType<
  typeof useMentionUserInfoLazyQuery
>;
export type MentionUserInfoSuspenseQueryHookResult = ReturnType<
  typeof useMentionUserInfoSuspenseQuery
>;
export type MentionUserInfoQueryResult = Apollo.QueryResult<
  MentionUserInfoQuery,
  MentionUserInfoQueryVariables
>;
export const MentionGroupInfoDocument = /*#__PURE__*/ gql`
  query MentionGroupInfo($groupId: GroupId!) {
    groupById(groupId: $groupId) {
      id
      name
    }
  }
`;

/**
 * __useMentionGroupInfoQuery__
 *
 * To run a query within a React component, call `useMentionGroupInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useMentionGroupInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMentionGroupInfoQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useMentionGroupInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    MentionGroupInfoQuery,
    MentionGroupInfoQueryVariables
  > &
    (
      | { variables: MentionGroupInfoQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MentionGroupInfoQuery, MentionGroupInfoQueryVariables>(
    MentionGroupInfoDocument,
    options,
  );
}
export function useMentionGroupInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MentionGroupInfoQuery,
    MentionGroupInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MentionGroupInfoQuery,
    MentionGroupInfoQueryVariables
  >(MentionGroupInfoDocument, options);
}
export function useMentionGroupInfoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MentionGroupInfoQuery,
    MentionGroupInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MentionGroupInfoQuery,
    MentionGroupInfoQueryVariables
  >(MentionGroupInfoDocument, options);
}
export type MentionGroupInfoQueryHookResult = ReturnType<
  typeof useMentionGroupInfoQuery
>;
export type MentionGroupInfoLazyQueryHookResult = ReturnType<
  typeof useMentionGroupInfoLazyQuery
>;
export type MentionGroupInfoSuspenseQueryHookResult = ReturnType<
  typeof useMentionGroupInfoSuspenseQuery
>;
export type MentionGroupInfoQueryResult = Apollo.QueryResult<
  MentionGroupInfoQuery,
  MentionGroupInfoQueryVariables
>;
export const MentionHexInfoDocument = /*#__PURE__*/ gql`
  query MentionHexInfo($hexId: HexId!) {
    hexById(hexId: $hexId) {
      id
      hexType
      currentDraft {
        id
        title
      }
      ...ProjectToolTipFragment
    }
  }
  ${ProjectToolTipFragmentDoc}
`;

/**
 * __useMentionHexInfoQuery__
 *
 * To run a query within a React component, call `useMentionHexInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useMentionHexInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMentionHexInfoQuery({
 *   variables: {
 *      hexId: // value for 'hexId'
 *   },
 * });
 */
export function useMentionHexInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    MentionHexInfoQuery,
    MentionHexInfoQueryVariables
  > &
    (
      | { variables: MentionHexInfoQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MentionHexInfoQuery, MentionHexInfoQueryVariables>(
    MentionHexInfoDocument,
    options,
  );
}
export function useMentionHexInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MentionHexInfoQuery,
    MentionHexInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MentionHexInfoQuery, MentionHexInfoQueryVariables>(
    MentionHexInfoDocument,
    options,
  );
}
export function useMentionHexInfoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MentionHexInfoQuery,
    MentionHexInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MentionHexInfoQuery,
    MentionHexInfoQueryVariables
  >(MentionHexInfoDocument, options);
}
export type MentionHexInfoQueryHookResult = ReturnType<
  typeof useMentionHexInfoQuery
>;
export type MentionHexInfoLazyQueryHookResult = ReturnType<
  typeof useMentionHexInfoLazyQuery
>;
export type MentionHexInfoSuspenseQueryHookResult = ReturnType<
  typeof useMentionHexInfoSuspenseQuery
>;
export type MentionHexInfoQueryResult = Apollo.QueryResult<
  MentionHexInfoQuery,
  MentionHexInfoQueryVariables
>;
export const MentionTableSummaryByIdDocument = /*#__PURE__*/ gql`
  query MentionTableSummaryById($dataSourceTableId: DataSourceTableId!) {
    dataSourceTableById(dataSourceTableId: $dataSourceTableId) {
      id
      name
      dbtDescription
      comment
      pinned
      dataSourceSchema {
        id
        name
        metadata {
          id
          status {
            ...StatusFragment
          }
        }
        dataSourceDatabase {
          id
          name
          dataConnectionId
          metadata {
            id
            status {
              ...StatusFragment
            }
          }
        }
      }
      metadata {
        id
        magicDescription
        status {
          ...StatusFragment
        }
      }
    }
  }
  ${StatusFragmentDoc}
`;

/**
 * __useMentionTableSummaryByIdQuery__
 *
 * To run a query within a React component, call `useMentionTableSummaryByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMentionTableSummaryByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMentionTableSummaryByIdQuery({
 *   variables: {
 *      dataSourceTableId: // value for 'dataSourceTableId'
 *   },
 * });
 */
export function useMentionTableSummaryByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    MentionTableSummaryByIdQuery,
    MentionTableSummaryByIdQueryVariables
  > &
    (
      | { variables: MentionTableSummaryByIdQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MentionTableSummaryByIdQuery,
    MentionTableSummaryByIdQueryVariables
  >(MentionTableSummaryByIdDocument, options);
}
export function useMentionTableSummaryByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MentionTableSummaryByIdQuery,
    MentionTableSummaryByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MentionTableSummaryByIdQuery,
    MentionTableSummaryByIdQueryVariables
  >(MentionTableSummaryByIdDocument, options);
}
export function useMentionTableSummaryByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MentionTableSummaryByIdQuery,
    MentionTableSummaryByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MentionTableSummaryByIdQuery,
    MentionTableSummaryByIdQueryVariables
  >(MentionTableSummaryByIdDocument, options);
}
export type MentionTableSummaryByIdQueryHookResult = ReturnType<
  typeof useMentionTableSummaryByIdQuery
>;
export type MentionTableSummaryByIdLazyQueryHookResult = ReturnType<
  typeof useMentionTableSummaryByIdLazyQuery
>;
export type MentionTableSummaryByIdSuspenseQueryHookResult = ReturnType<
  typeof useMentionTableSummaryByIdSuspenseQuery
>;
export type MentionTableSummaryByIdQueryResult = Apollo.QueryResult<
  MentionTableSummaryByIdQuery,
  MentionTableSummaryByIdQueryVariables
>;
